import { useEffect, useState } from "react";
import IOption from "../../../interfaces/IOption";

// generates coorect options for min max selectors, so user won't be select more than max value, or lesss than min value
const useMinMax = (minValue: IOption, maxValue: IOption, initMinValues: IOption[], initMaxValues: IOption[]) => {
  const [minValues, setMinValues] = useState<IOption[]>(initMinValues)
  const [maxValues, setMaxValues] = useState<IOption[]>(initMaxValues)
  
  const adjustMaxOptions = (minSelected: IOption | null, maxOptions: IOption[], setter: (value: IOption[]) => void) => {
    if (minSelected && minSelected.value !== "") {
      const selected = minSelected.value;

      const newMaxOptions = maxOptions.filter(option => {
        if (option.value === "") return true;
        return option.value > selected
      })
      setter(newMaxOptions);
    }
    else setter(maxOptions); // restoring default values
  }
  const adjustMinOptions = (maxSelected: IOption | null, minOptions: IOption[], setter: (value: IOption[]) => void) => {
    if (maxSelected && maxSelected.value !== "") {
      const selected = maxSelected.value;
      
      const newMinOptions = minOptions.filter(option => {
        if (option.value === "") return true;
        return option.value < selected
      });

      setter(newMinOptions);
    }
    else setter(minOptions); // restoring default values
  }

  useEffect(() => {
    adjustMinOptions(maxValue, initMinValues, setMinValues);
    adjustMaxOptions(minValue, initMaxValues, setMaxValues);
  }, [minValue, maxValue, initMinValues, initMaxValues]);

  return [minValues, maxValues];
}

export default useMinMax